import axiosInstance from '../variables/api/axiosInstance';
import { avecLibelleTraduit } from '../i18n/libelles';

const BASE = '/v1/journal-activite';

const unwrapPaginated = (res) => {
  const d = res?.data?.data;
  const list = Array.isArray(d) ? d : (d?.content || []);
  return {
    items: list,
    totalElements: res?.data?.totalElements ?? d?.totalElements ?? list.length,
    currentPage: res?.data?.currentPage ?? d?.number ?? 0,
    pageSize: res?.data?.pageSize ?? d?.size ?? list.length,
    totalPages: res?.data?.totalPages ?? d?.totalPages ?? 1,
  };
};

export async function listerActivites(page = 0, size = 25, params = {}) {
  return unwrapPaginated(
    await axiosInstance.get(BASE, { params: { page, size, ...params } })
  );
}

/** Modules reellement presents dans le journal - evite un filtre qui promet plus que la base. */
export async function listerModules() {
  const res = await axiosInstance.get(`${BASE}/modules`);
  return res?.data?.data || [];
}

/**
 * Vocabulaire du journal (miroir de TypeActionJournal cote backend).
 * Couleurs alignees sur ACTION_COLORS de rbaColors.js : creation verte,
 * modification orange, suppression rouge - le lecteur retrouve le code couleur
 * de l'ecran Habilitations.
 */
export const TYPES_ACTION = avecLibelleTraduit({
  CONNEXION: { color: 'blue' },
  DECONNEXION: { color: 'default' },
  ECHEC_CONNEXION: { color: 'volcano' },
  CONSULTATION: { color: 'cyan' },
  CREATION: { color: 'green' },
  MODIFICATION: { color: 'orange' },
  SUPPRESSION: { color: 'red' },
}, 'referentiels:typesActionJournal');
